import * as H from "history";
import { Initial } from "redmond";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { RequestState } from "../reducer";
import {
  FETCH_PREMIUM_OFFERS_SHOP,
  SET_PREMIUM_OFFERS_SHOP_RESULTS,
} from "./constants";

export interface IFetchPremiumOffersShop {
  type: FETCH_PREMIUM_OFFERS_SHOP;
  history: H.History;
  params: IOfferAvailabilityRequest;
}

export const fetchPremiumOffersShop = (
  history: H.History,
  params: IOfferAvailabilityRequest
): IFetchPremiumOffersShop => ({
  type: FETCH_PREMIUM_OFFERS_SHOP,
  history,
  params,
});

export interface ISetPremiumOffersShopResults {
  type: SET_PREMIUM_OFFERS_SHOP_RESULTS;
  payload: RequestState<IOfferAvailabilityRequest, Initial, unknown>;
}

export const setPremiumOffersShopResults = (
  payload: RequestState<IOfferAvailabilityRequest, Initial, unknown>
): ISetPremiumOffersShopResults => ({
  type: SET_PREMIUM_OFFERS_SHOP_RESULTS,
  payload,
});

export type PremiumCollectionOffersSearchActions =
  | IFetchPremiumOffersShop
  | ISetPremiumOffersShopResults;
